import * as Sentry from "@sentry/react";
import { getEnv } from "./utils/runtime-config";

const dsn = getEnv("SENTRY_DSN") || import.meta.env.VITE_SENTRY_DSN || "";
const tracesSampleRateStr = getEnv("SENTRY_TRACES_SAMPLE_RATE");
const tracesSampleRate = tracesSampleRateStr
  ? Number.parseFloat(tracesSampleRateStr)
  : 0.0;
const backendUrl = getEnv("VITE_BACKEND_URL");

Sentry.init({
  dsn,
  sendDefaultPii: getEnv("SENTRY_SEND_DEFAULT_PII") !== "false",
  tracesSampleRate,
  integrations: [Sentry.browserTracingIntegration()],
  tracePropagationTargets: ["localhost", backendUrl, /^\/api/].filter(Boolean),
  environment:
    getEnv("SENTRY_ENV") || import.meta.env.VITE_SENTRY_ENV || "development",
  ignoreErrors: [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications.",
    "AbortError",
    "canceled",
  ],
});
